(() => {
  if (window.DislejPremiumCard) return;
  window.DislejPremiumCard = true;

  const closeAllPanels = (exceptCard = null) => {
    document.querySelectorAll('[data-dislej-product-card].is-variant-open').forEach((card) => {
      if (exceptCard && card === exceptCard) return;

      card.classList.remove('is-variant-open');

      const panel = card.querySelector('[data-dislej-variant-panel]');
      const toggle = card.querySelector('[data-dislej-variant-toggle]');

      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });

    // Re-enable body scroll
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-dislej-variant-toggle]');

    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const card = toggle.closest('[data-dislej-product-card]');
      const panel = card && card.querySelector('[data-dislej-variant-panel]');

      if (!card || !panel) return;

      const willOpen = panel.hidden;

      closeAllPanels(card);

      panel.hidden = !willOpen;
      card.classList.toggle('is-variant-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      // Lock body scroll when opening
      if (willOpen) {
        document.body.style.overflow = 'hidden';
      }

      return;
    }

    const backdrop = event.target.closest('[data-dislej-variant-backdrop]');

    if (backdrop) {
      event.preventDefault();
      closeAllPanels();
      return;
    }

    const variantButton = event.target.closest('[data-dislej-variant-value]');

    if (variantButton) {
      event.preventDefault();
      event.stopPropagation();

      if (variantButton.disabled) return;

      const form = variantButton.closest('[data-dislej-premium-form]');
      const input = form && form.querySelector('.dislej-card__variant-id');

      if (!form || !input) return;

      input.value = variantButton.dataset.dislejVariantValue;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        const submit = document.createElement('button');
        submit.type = 'submit';
        submit.hidden = true;
        form.appendChild(submit);
        submit.click();
        submit.remove();
      }

      closeAllPanels();
      return;
    }

    if (!event.target.closest('[data-dislej-product-card]')) {
      closeAllPanels();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllPanels();
    }
  });

  // AJAX add-to-cart functionality
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-dislej-ajax-cart]');

    if (!form) return;

    event.preventDefault();

    const submitButton = form.querySelector('.dislej-card__quick-add:not([disabled])');
    if (!submitButton) return;

    const formData = new FormData(form);

    // Show loading state
    submitButton.classList.add('is-loading');

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      const data = await response.json();

      // Update cart drawer/announcement if they exist
      if (window.theme && window.theme.onCartUpdate) {
        window.theme.onCartUpdate(data);
      }

      // Dispatch custom event for cart updates
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

      // Optionally show success feedback
      submitButton.classList.remove('is-loading');
      submitButton.classList.add('is-success');

      setTimeout(() => {
        submitButton.classList.remove('is-success');
      }, 2000);

    } catch (error) {
      console.error('Add to cart error:', error);
      submitButton.classList.remove('is-loading');
      submitButton.classList.add('is-error');

      setTimeout(() => {
        submitButton.classList.remove('is-error');
      }, 2000);
    }
  });

  // Mobile slider dots functionality
 const setupSliderDots = (slider) => {
    const mediaWrap = slider.closest('.dislej-card__media-wrap');
    if (!mediaWrap) return;

    const dotsContainer = mediaWrap.querySelector('[data-dislej-slider-dots]');
    if (!dotsContainer) return;

    const slides = slider.querySelectorAll('.dislej-card__mobile-slide');
    const dots = dotsContainer.querySelectorAll('.dislej-card__slider-dot');

    // Handle dot clicks
    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const slideIndex = parseInt(dot.dataset.gotoSlide, 10);
        if (isNaN(slideIndex)) return;

        const targetSlide = slides[slideIndex];
        if (!targetSlide) return;

        targetSlide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      });
    });

    // Update active dot on scroll
    let scrollTimeout;
    const updateActiveDot = () => {
      const sliderRect = slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + (sliderRect.width / 2);
      let activeIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + (slideRect.width / 2);
        const distance = Math.abs(sliderCenter - slideCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('dislej-card__slider-dot--active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 50);
    });

    /*
      JS-driven touch dragging.

      On iPhone, a parent element that clips overflow can silently disable
      NATIVE touch-scrolling of this carousel while programmatic scrolling
      (the desktop arrows) keeps working. To make the swipe work regardless,
      we move the carousel ourselves: read the finger movement and set
      scrollLeft directly (the same thing the arrows do).

      - We only take over once the gesture is clearly horizontal, so vertical
        page scrolling still works.
      - A plain tap never triggers this, so tapping the image still opens the
        product page.
      - On release we snap to the nearest image.
    */
    if (slider.dataset.dislejTouchDrag !== 'true') {
      slider.dataset.dislejTouchDrag = 'true';

      let dragStartX = 0;
      let dragStartY = 0;
      let dragStartScrollLeft = 0;
      let dragActive = false;
      let dragAxis = null;

      slider.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.touches[0];
          dragStartX = touch.clientX;
          dragStartY = touch.clientY;
          dragStartScrollLeft = slider.scrollLeft;
          dragActive = true;
          dragAxis = null;
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchmove',
        (event) => {
          if (!dragActive) return;

          const touch = event.touches[0];
          const deltaX = touch.clientX - dragStartX;
          const deltaY = touch.clientY - dragStartY;

          if (
            dragAxis === null &&
            (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5)
          ) {
            dragAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
          }

          if (dragAxis === 'x') {
            slider.scrollLeft = dragStartScrollLeft - deltaX;
            event.preventDefault();
          }
        },
        { passive: false }
      );

      const finishTouchDrag = () => {
        if (!dragActive) return;
        dragActive = false;

        if (dragAxis !== 'x') return;

        let nearestSlide = slides[0];
        let nearestDistance = Infinity;

        slides.forEach((slide) => {
          const distance = Math.abs(slide.offsetLeft - slider.scrollLeft);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestSlide = slide;
          }
        });

        if (nearestSlide) {
          slider.scrollTo({
            left: nearestSlide.offsetLeft,
            behavior: 'smooth'
          });
        }
      };

      slider.addEventListener('touchend', finishTouchDrag, { passive: true });
      slider.addEventListener('touchcancel', finishTouchDrag, { passive: true });
    }

    // Initial update
    setTimeout(updateActiveDot, 100);
  };

  // Initialize sliders on page load and when new content is added
  const initializeSliders = () => {
    document.querySelectorAll('[data-dislej-mobile-slider]').forEach((slider) => {
      setupSliderDots(slider);
    });
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSliders);
  } else {
    initializeSliders();
  }

  // Re-initialize when new cards are added to DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches('[data-dislej-mobile-slider]')) {
            setupSliderDots(node);
          } else {
            const sliders = node.querySelectorAll('[data-dislej-mobile-slider]');
            sliders.forEach((slider) => setupSliderDots(slider));
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();